<template>
  <div />
</template>
<script>
import request from '@/utils/request'
import { getUrlKey } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
import router from '@/router'
export default {
  components: {
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
  },
  data() {
    return {
      loading: false
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.init()
      }
    }

  },
  created() {
  },
  methods: {
    init() {
      var divebossWxUInfo = getUrlKey('divebossWxUInfo')
      if (divebossWxUInfo) {
        this.$emit('finish')
        return
      }
      if (this.loading) {
        return
      }

      this.loading = true
      request({
        url: '/user/checkUserFollowWx',
        method: 'post'
      }).then(response => {
        this.loading = false
        // this.$emit('finish', false)
        if (!response.success) {
          return
        }
        if (!response.data.isNeed) {
          this.$emit('finish')
        } else {
          this.getInfo()
        }
      })
    },
    getInfo() {
      this.loading = true
      const base32 = require('base32')
      var system = getUrlKey('system')
      var Backrouter = router.history.current.fullPath
      if (Backrouter.indexOf('?') >= 0) {
        Backrouter += '&divebossWxUInfo=1'
      } else {
        Backrouter += '?divebossWxUInfo=1'
      }
      var url = GetSelfUrl() + 'loginCallbackThirdInfo?system=' + system + '&url=' + base32.encode(Backrouter)
      request({
        url: '/user/reCheckUserFollowWx',
        method: 'post',
        data: {
          url: url
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        window.location.href = response.data
      })
    }
  }
}
</script>

<style scoped>
</style>
